module.exports = __webpack_public_path__ + "static/img/bk.95eb0dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bk.svg
// module id = 285
// module chunks = 0